export default "__VITE_ASSET__BpygepMO__"